/* eslint-disable no-extra-boolean-cast */
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { toClose } from './LeftSidebarActions';
import styles from './LeftSidebarMenuItem.scss';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import { DownIcon } from 'components/Icons';

const rootClassName = styles.rootClassName;

const LeftSidebarMenuItem = ({ id, label, path, normalIcon, hoverIcon, subMenus }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const toggleSubMenu = useCallback(() => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  }, []);

  const DownIconButton = React.memo(() => (
    <div className={`${rootClassName}-dropdown-icon ${isOpen ? 'opened' : ''}`}>
      <DownIcon />
    </div>
  ));

  const Content = () => (
    <>
      <div className={rootClassName + '-icon-container'}>
        {typeof normalIcon === 'string' ? (
          <img
            src={normalIcon}
            className={getMergedClassNames([
              rootClassName + '-icon',
              rootClassName + '-normal-icon',
            ])}
            alt='icone-normal'
            loading='lazy'
          />
        ) : (
          <div
            className={getMergedClassNames([
              rootClassName + '-material-icon',
              rootClassName + '-material-normal-icon',
            ])}
          >
            {normalIcon}
          </div>
        )}
        {typeof hoverIcon === 'string' ? (
          <img
            src={hoverIcon}
            className={getMergedClassNames([
              rootClassName + '-icon',
              rootClassName + '-hover-icon',
            ])}
            alt='icone-hover'
            loading='lazy'
          />
        ) : (
          <div
            className={getMergedClassNames([
              rootClassName + '-material-icon',
              rootClassName + '-material-hover-icon',
            ])}
          >
            {hoverIcon}
          </div>
        )}
      </div>
      <span className={rootClassName + '-label'}>{label}</span>
    </>
  );

  return (
    <div className={rootClassName}>
      {!!subMenus.length ? (
        <button
          className={`${rootClassName}-navlink ${isOpen ? 'opened' : ''}`}
          onClick={toggleSubMenu}
        >
          <Content />
          <DownIconButton />
        </button>
      ) : (
        <NavLink
          id={id}
          className={`${rootClassName}-navlink`}
          to={path}
          activeClassName={'actived'}
          onClick={() => dispatch(toClose())}
        >
          <Content />
        </NavLink>
      )}

      {isOpen && !!subMenus.length && (
        <ul className={`${rootClassName}-submenu`}>
          {subMenus.map(({ idSubMenu, pathSubMenu, labelSubMenu }) => (
            <NavLink
              id={idSubMenu}
              key={idSubMenu}
              className={`${rootClassName}-navlink`}
              to={pathSubMenu}
              activeClassName='actived'
              onClick={() => dispatch(toClose())}
            >
              <li>{labelSubMenu}</li>
            </NavLink>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LeftSidebarMenuItem;